import { render, staticRenderFns } from "./PressKits.vue?vue&type=template&id=6a954f34&scoped=true&"
import script from "./PressKits.vue?vue&type=script&lang=js&"
export * from "./PressKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a954f34",
  null
  
)

export default component.exports